"use client";

import { c as _c } from "react/compiler-runtime";
import { submitContactSales } from "@/actions/subscription";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useEffect, useState } from "react";
import { toast } from "sonner";
const PLAN_NAMES: Record<"professional" | "premium", string> = {
  professional: "Profesional",
  premium: "Premium"
};
export function ContactSalesDialog(t0) {
  const $ = _c(45);
  const {
    open,
    onOpenChange,
    plan,
    defaultEmail
  } = t0;
  const [email, setEmail] = useState(defaultEmail ?? "");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  let t1;
  let t2;
  if ($[0] !== defaultEmail || $[1] !== open) {
    t1 = () => {
      if (open) {
        setEmail(defaultEmail ?? "");
        setMessage("");
      }
    };
    t2 = [open, defaultEmail];
    $[0] = defaultEmail;
    $[1] = open;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== email || $[5] !== message || $[6] !== onOpenChange || $[7] !== plan) {
    t3 = async event => {
      event.preventDefault();
      setSubmitting(true);
      const result = await submitContactSales({
        plan,
        replyEmail: email,
        message
      });
      setSubmitting(false);
      if (result.success) {
        toast.success("Solicitud enviada. Te contactaremos pronto.");
        onOpenChange(false);
      } else {
        toast.error(result.error);
      }
    };
    $[4] = email;
    $[5] = message;
    $[6] = onOpenChange;
    $[7] = plan;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleSubmit = t3;
  const t4 = PLAN_NAMES[plan];
  let t5;
  if ($[9] !== t4) {
    t5 = <DialogTitle>Contactar para plan {t4}</DialogTitle>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DialogDescription>Cuéntanos qué necesitas y te responderemos al correo que indiques.</DialogDescription>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <DialogHeader>{t5}{t6}</DialogHeader>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Label htmlFor="contact-email">Email de contacto</Label>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => setEmail(e.target.value);
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== email) {
    t10 = <div className="space-y-2">{t8}<Input id="contact-email" type="email" required={true} value={email} onChange={t9} placeholder="tu@empresa.com" autoComplete="email" /></div>;
    $[16] = email;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Label htmlFor="contact-message">Mensaje (opcional)</Label>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e_0 => setMessage(e_0.target.value);
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== message) {
    t13 = <div className="space-y-2">{t11}<Textarea id="contact-message" value={message} onChange={t12} placeholder={"\xBFCu\xE1ntos usuarios? \xBFAlg\xFAn detalle relevante?"} rows={5} maxLength={2000} /></div>;
    $[20] = message;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== onOpenChange) {
    t14 = () => onOpenChange(false);
    $[22] = onOpenChange;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== submitting || $[25] !== t14) {
    t15 = <Button type="button" variant="outline" onClick={t14} disabled={submitting}>Cancelar</Button>;
    $[24] = submitting;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = submitting ? "Enviando..." : "Enviar solicitud";
  let t17;
  if ($[27] !== submitting || $[28] !== t16) {
    t17 = <Button type="submit" disabled={submitting}>{t16}</Button>;
    $[27] = submitting;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t15 || $[31] !== t17) {
    t18 = <DialogFooter className="gap-2 sm:gap-0">{t15}{t17}</DialogFooter>;
    $[30] = t15;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== handleSubmit || $[34] !== t10 || $[35] !== t13 || $[36] !== t18) {
    t19 = <form onSubmit={handleSubmit} className="space-y-4">{t10}{t13}{t18}</form>;
    $[33] = handleSubmit;
    $[34] = t10;
    $[35] = t13;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19 || $[39] !== t7) {
    t20 = <DialogContent className="sm:max-w-md">{t7}{t19}</DialogContent>;
    $[38] = t19;
    $[39] = t7;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== onOpenChange || $[42] !== open || $[43] !== t20) {
    t21 = <Dialog open={open} onOpenChange={onOpenChange}>{t20}</Dialog>;
    $[41] = onOpenChange;
    $[42] = open;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
}